import React from 'react';

import { selectorScrollTo } from '../../../../../helpers/scrollTo';

import StarRating from '../../../../_ui/_blocks/StarRating/StarRating';
import { RedisTreatment } from '../../../../../lib/redis/types/RedisTreatment';

interface Props {
    review?: RedisTreatment['selectedReview'] | null;
}

const ReviewsLink = ({ review }: Props) => {
    const scrollToSelector = '#treatment-reviews';

    const onReviewsClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        selectorScrollTo(scrollToSelector);
    };

    return (
        <div className="flex items-center gap-050 h-[1.3125rem] type-090 leading-none">
            <StarRating rating={review?.averageRating || 0} loading="eager" />
            {review?.numRatings ? (
                <a
                    onClick={onReviewsClick}
                    href={scrollToSelector}
                    className="underline hover:no-underline"
                    title="View reviews"
                >
                    {review.numRatings} reviews
                </a>
            ) : (
                <span>0 reviews</span>
            )}
        </div>
    )
}

export default ReviewsLink;
